import { useEffect, useState } from "react";
import { RiResetLeftFill } from "react-icons/ri";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import BackButton from "../../components/BackButton";
import TitleRecordFunction from "../../components/TitleRecordFunction";
import api from '../../api/manage_database/FlowMeterReq';
import { toast } from 'sonner';
import SelectMode from "../../components/SelectMode";
import { FaSave } from "react-icons/fa";
import ReloadButton from "../../components/ReloadButton";

const ManageUploadedData = () => {
    const { flow_meter_id } = useParams();
    const [flowMeterData, setFlowMeterData] = useState({
        'place': '',
        'thoroughfare': '',
        'type_line': '',
        'dataframe_type': '',
    });
    const [selectedMode, setSelectedMode] = useState('');
    const [modes, setModes] = useState('');
    const [cnt, setCnt] = useState('');
    const [delay, setDelay] = useState('');

    const [paramsStates, setParamStates] = useState();
    const handleCheckBoxChange = (key) => {
        setParamStates((prev) => ({...prev, [key]: !prev[key]}))
    }

    const handleChangeDelay = (e) => {
        setDelay(e.target.value);
    }
    
    const handleChangeCnt = (e) => {
        setCnt(e.target.value);
    }

    const [allTrueState, setAllTrueStates] = useState(true);

    const toggleAllCheckboxes = () => {
        const newState = Object.keys(paramsStates).reduce((acc, key) => {
          acc[key] = !allTrueState;
          return acc;
        }, {});
        setParamStates(newState);
        setAllTrueStates(!allTrueState);
      };

    const navigate = useNavigate();

    useEffect(() => {
        const getAvailableModeTypes = async() => {
            try {
                const response = await api.get(`/available-mode-types`, {withCredentials: true})
                if (response.data.success) {
                    setModes(response.data.payload.types)
                } else {
                    toast.error('Not got data from database');
                }
            } catch (err) {
                console.log(err.response);
            }
        };
        getAvailableModeTypes();
    }, []);


    useEffect(() => {
        const getFlowMeterAllData = async() => {
            try {
                const response = await api.get(`all-data/${flow_meter_id}`, {withCredentials: true})
                if (response.data.success) {
                    const received_data = {
                        'place': response.data.payload.place,
                        'thoroughfare': response.data.payload.thoroughfare,
                        'type_line': response.data.payload.type_line,
                        'dataframe_type': response.data.payload.dataframe_type,
                    }
                    setFlowMeterData(received_data);
                    if (response.data.payload.mode === 'ALL') {
                        setSelectedMode(modes[0][0])
                    } else {
                        setSelectedMode(modes[1][0])
                    }
                    setCnt(response.data.payload.cnt);
                    setDelay(response.data.payload.delay);
                    setParamStates(response.data.payload.working_parameters);
                } else {
                    toast.error('Not got data from database');
                }
                
            } catch (err) {
                console.log(err.response);
            }
        };
        if (modes) {
            getFlowMeterAllData();
        }
    }, [modes]);

    const handleSaveNewConfiguration = async (e) => {
            e.preventDefault()
            if (delay < 1000){
                toast.error("It is not possible to set below than 1000 miliseconds!")    
                return
            }
            const min_cnt = 1;
            const max_cnt = 700;
            if (cnt < min_cnt || cnt > max_cnt) {
                toast.error(`It is not possible to set ${cnt}! Possible is from ${min_cnt} to ${max_cnt}!`);
            }
            try {
                const response = await api.put(
                    '/flow-meter-working-parameters',
                    {
                        cnt: cnt,
                        delay: delay,
                        flow_meter_id: flow_meter_id,
                        mode: selectedMode,
                        working_parameters: paramsStates
                    },
                    {
                        withCredentials: true
                    }
                );
                if (response.data.success) {
                    toast.success(response.data.message);
                } else {
                    toast.error(response.data.message)
                }
            } catch (err) {
                console.log(err.response)
            }
        };
    
    return (
        <div className='manage-uploaded-data-container'>
            <h2 className='manage-uploaded-data-title'>Flow Meter &nbsp; <ReloadButton /> </h2>  
            <div className="manage-uploaded-data-container-background">
                <table className='manage-uploaded-data-table-style'>
                    <tbody>
                        <tr>
                            <td>Dataframe Type:</td>
                            <td>{flowMeterData.dataframe_type !== '' && flowMeterData.dataframe_type}</td>
                        </tr>
                        <tr>
                            <td>Location:</td>
                            <td>
                                {flowMeterData.place !== '' && flowMeterData.place}<br />
                                {flowMeterData.thoroughfare !== '' && flowMeterData.thoroughfare}<br />
                                {flowMeterData.type_line !== '' && flowMeterData.type_line.toLocaleUpperCase()}
                            </td>
                        </tr>
                        {modes && <tr>
                            <td>Mode:</td>
                            <td>
                                <SelectMode
                                    modes={modes}
                                    selectedMode={selectedMode}
                                    setSelectedMode={setSelectedMode}
                                />
                            </td>
                        </tr>}
                    </tbody>       
                </table>
                {selectedMode !== '' && <div className={selectedMode === 'MANUAL'? "manage-uploaded-data-card fade-in" : "manage-uploaded-data-card fade-out"}>
                    <button className='manage-uploaded-data-button' onClick={toggleAllCheckboxes}>
                            Change all to {allTrueState? 'False': 'True'}
                    </button>
                    {Object.keys(paramsStates).map((key) => (
                        <div key={key} className="manage-upload-data-params-container">
                            {key}
                            <input
                                type="checkbox"
                                checked={paramsStates[key]}
                                onChange={() => handleCheckBoxChange(key)}
                            />
                        </div>
                    ))}
                </div>}
                <div className="manage-uploaded-delay-cnt-card-wrapper">
                    <div className="manage-uploaded-delay-cnt-card">
                        Probes amount
                        <input
                                type='number'
                                value={cnt}
                                onChange={handleChangeCnt}
                        />
                    </div>
                    <div className="manage-uploaded-delay-cnt-card">
                        Delay [ms]
                        <input
                                type='number'
                                value={delay}
                                onChange={handleChangeDelay}
                        />
                    </div>
                    
                </div>
            </div>
                
            <button className='manage-uploaded-data-button-save' onClick={handleSaveNewConfiguration}>
                        Save new Configuration &nbsp; <FaSave/>
                </button>
            <BackButton
                navigateTo='/manage-database'
            />
        </div>
    )
}

export default ManageUploadedData;